// src/components/Dashboard/ItemList.js
import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import MarkdownRenderer from './MarkdownRenderer';

const ItemList = ({ items, itemType }) => {
  const [expandedTopics, setExpandedTopics] = useState({});

  useEffect(() => {
    console.log("Items received by ItemList:", items);
  }, [items]);

  const toggleTopic = (topic) => {
    setExpandedTopics(prev => ({ ...prev, [topic]: !prev[topic] }));
  };

  return Object.entries(items).map(([topic, topicItems]) => (
    <div key={topic} className="mb-4 border rounded shadow-sm">
      <button
        onClick={() => toggleTopic(topic)}
        className="flex justify-between items-center w-full p-3 bg-gray-50 rounded-t"
      >
        <span className="font-semibold">{topic}</span>
        {expandedTopics[topic] ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      {expandedTopics[topic] && (
        <ul className="mt-2 space-y-2 p-3">
          {topicItems.map((item) => (
            <li key={item.id} className="pb-2 border-b text-left">
              {itemType === 'faq' ? (
                <>
                  <div className="font-medium">
                    <MarkdownRenderer>{item.Question}</MarkdownRenderer>
                  </div>
                  <div className="mt-1">
                    <MarkdownRenderer>{item.Answer}</MarkdownRenderer>
                  </div>
                </>
              ) : itemType === 'utterance' ? (
                <MarkdownRenderer>{item.Utterance}</MarkdownRenderer>
              ) : (
                <>
                  {item.Question && (
                    <div className="font-medium">
                      <MarkdownRenderer>{item.Question}</MarkdownRenderer>
                    </div>
                  )}
                  <div className="mt-1">
                    <strong>Answer:</strong> <MarkdownRenderer>{item.Answer}</MarkdownRenderer>
                  </div>
                </>
              )}
              <small className="text-gray-500 block mt-1">
                Added by {item.addedBy} on {item.addedAt?.toDate().toLocaleString()}
              </small>
            </li>
          ))}
        </ul>
      )}
    </div>
  ));
};

export default ItemList;